import { render } from "./ProjectAnalysisOutliersItem.vue?vue&type=template&id=363275f4"
import script from "./ProjectAnalysisOutliersItem.vue?vue&type=script&lang=js"
export * from "./ProjectAnalysisOutliersItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__